import * as React from "react";
import { ArrowWide } from "../../../assets/svg/ArrowWide";
import { SvgContainer } from "../svg-container/SvgContainer";
export var UpgradeTransitionArrow = function (_a) {
    var children = _a.children;
    return (React.createElement(SvgContainer, { name: "arrow", svg: ArrowWide }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/UpgradeTransitionArrow.tsx
// module id = 2634
// module chunks = 3